import React, {useState, useEffect, useContext} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Typography from '@mui/material/Typography';
import ArgoButtonHook from "./ArgoButtonHook";
import {BUILD_KEY, BUILD_NUMBER, BUILD_TIMESTAMP, GIT_REVISION, GIT_BRANCH, RELEASE_NAME} from "../../constants/buildConstants";
import {deriveDisplayVersion} from "../../utilities/versionUtils";
import UserContext from "../../UserContext"


export default function ArgoAboutDialogHook(props) {
    const [open, setOpen] = useState(false);

    const theme = useContext(UserContext); // From blueTheme.js

    const fileName = props.fileName ?? "NoFileName";
    const backendVersionInfo = props.backendVersionInfo;

    const uniqueIdentifier = fileName + "-ArgoAboutDialogHook";

    const frontendDisplayVersion = deriveDisplayVersion(RELEASE_NAME, GIT_BRANCH);

    useEffect(() => {
        // Update the document title using the browser API
        setOpen(props.open);
    }, [props.open]);

    const handleClose = () => {
        props.close();
    };

    const stripRefsPrefix = (ref) => {
        if (!ref) return ref;
        if (ref.startsWith("refs/heads/")) return ref.substring("refs/heads/".length);
        if (ref.startsWith("refs/tags/")) return ref.substring("refs/tags/".length);
        return ref;
    };

    return (
        <div>
            <Dialog
                id={uniqueIdentifier}
                open={open}
                onClose={handleClose}
                fullWidth={true}
                PaperProps={{
                    sx: {
                        backgroundColor: "white",
                        boxShadow: "none",
                        width: "100%",
                        fontFamily: theme.fontFamily
                    },
                }}
            >
                <DialogTitle id={uniqueIdentifier + "-DialogTitle"} sx={{fontWeight: "bold"}}>
                    {"About"}
                </DialogTitle>
                <DialogContent style={{paddingBottom: "0"}}>

                    <List dense subheader={<ListSubheader disableSticky>Frontend</ListSubheader>}>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary={"Version: " + frontendDisplayVersion}/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary={"Build Number: " + BUILD_NUMBER}/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary={"Build Key: " + BUILD_KEY}/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary={"Build Timestamp: " + BUILD_TIMESTAMP}/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary={"Git Ref: " + stripRefsPrefix(GIT_BRANCH)}/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText primary={"Git Revision: " + GIT_REVISION}/>
                            </ListItemButton>
                        </ListItem>
                    </List>

                    <Divider sx={{my: 1}}/>

                    <List dense subheader={<ListSubheader disableSticky>Backend</ListSubheader>}>
                        {backendVersionInfo ? (
                            <>
                                <ListItem disablePadding>
                                    <ListItemButton>
                                        <ListItemText primary={"Version: " + (backendVersionInfo.displayVersion || "")}/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemButton>
                                        <ListItemText primary={"Artifact Version: " + (backendVersionInfo.version || "")}/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemButton>
                                        <ListItemText primary={"Build Number: " + (backendVersionInfo.buildNumber || "")}/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemButton>
                                        <ListItemText primary={"Build Time: " + (backendVersionInfo.time || "")}/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemButton>
                                        <ListItemText primary={"Git Ref: " + stripRefsPrefix(backendVersionInfo.gitRef || "")}/>
                                    </ListItemButton>
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemButton>
                                        <ListItemText primary={"Git SHA: " + (backendVersionInfo.gitSha || "")}/>
                                    </ListItemButton>
                                </ListItem>
                            </>
                        ) : (
                            <ListItem disablePadding>
                                <ListItemButton>
                                    <Typography color="text.secondary">Backend version info unavailable</Typography>
                                </ListItemButton>
                            </ListItem>
                        )}
                    </List>

                </DialogContent>
                <DialogActions>
                    <ArgoButtonHook
                        fileName="ArgoAboutDialogHook"
                        fieldName="close"
                        variant="text"
                        label="Close"
                        width={100}
                        onClick={handleClose}
                    />
                </DialogActions>
            </Dialog>
        </div>
    );
}
